import _defineProperty from "/drone/src/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n    flex: 0 0 auto;\n    cursor: pointer;\n    ", ";\n\n    color: ", ";\n    font-size: ", ";\n\n    padding-top: ", ";\n    padding-left: ", ";\n    padding-bottom: ", ";\n    line-height: normal;\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n    flex: 0 0 auto;\n\n    font-size: ", ";\n\n    margin-right: ", ";\n    padding-top: ", ";\n    padding-bottom: ", ";\n\n    ", ";\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n        color: ", ";\n    "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    flex-shrink: 0;\n\n    margin-left: ", ";\n    padding-top: ", ";\n    padding-bottom: ", ";\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    flex-shrink: 0;\n    align-self: center;\n\n    margin-left: ", ";\n    padding-top: ", ";\n    padding-bottom: ", ";\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    flex-grow: 1;\n\n    ", ";\n    line-height: 1.3;\n    color: ", ";\n\n    padding-top: ", ";\n    padding-bottom: ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    flex-grow: 1;\n    align-self: center;\n    display: flex;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    box-sizing: border-box;\n    border: 1px solid ", ";\n    display: flex;\n    justify-content: space-between;\n    position: relative;\n\n    border-radius: ", ";\n    background-color: ", ";\n\n    padding-left: ", ";\n    padding-right: ", ";\n\n    ", "\n    ", ";\n    ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n        border-color: ", ";\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled, { css } from 'styled-components';
import { marginAttributes } from '../../system/attributes';
import { borderRadius, color, noTextInteraction, pixelToRem, spacing, typography } from '../../system/mixins';
import { getPropsBlocker } from '../../utils';
import { messageLevels } from './constants';
import { fontSize03 } from '../../tokens';
import { getComponentOverride } from '../../system/mixins/getComponentOverride';
var propertyList = {
  onClose: true,
  disableCloseButton: true,
  disableIcon: true,
  actions: true,
  extra: true,
  level: true,
  error: true,
  warning: true,
  info: true,
  success: true
};

var getColorNameByMessageLevel = function getColorNameByMessageLevel(_ref) {
  var level = _ref.level,
      error = _ref.error,
      success = _ref.success,
      warning = _ref.warning;

  if (level === messageLevels.error || error) {
    return 'error';
  }

  if (level === messageLevels.success || success) {
    return 'accent';
  }

  if (level === messageLevels.warning || warning) {
    return 'warning';
  }

  return 'primary';
};

var getRootDynamicStyle = function getRootDynamicStyle(props) {
  var level = getColorNameByMessageLevel(props);
  return css(_templateObject(), color("".concat(level, ".main")));
};

export var MessageRoot = styled.div.withConfig(getPropsBlocker(propertyList))(_templateObject2(), color('primary.main'), borderRadius('soft'), color('neutral.00'), spacing(4), spacing(4), getRootDynamicStyle, getComponentOverride('Message'), marginAttributes);
export var MessageCentral = styled.div.withConfig(getPropsBlocker(propertyList))(_templateObject3());
export var MessageContent = styled.div.withConfig(getPropsBlocker(propertyList))(_templateObject4(), typography('paragraphMedium'), color('neutral.06'), spacing(4), spacing(4));
export var MessageActions = styled.div.withConfig(getPropsBlocker(propertyList))(_templateObject5(), spacing(4), spacing(1), spacing(1));
export var MessageExtra = styled.div.withConfig(getPropsBlocker(propertyList))(_templateObject6(), spacing(4), spacing(2), spacing(2));

var MessageIconWrapper = function MessageIconWrapper(_ref2) {
  var children = _ref2.children,
      restProps = _objectWithoutProperties(_ref2, ["children"]);

  return children(_objectSpread({}, restProps));
};

var getIconDynamicStyle = function getIconDynamicStyle(props) {
  var level = getColorNameByMessageLevel(props);
  return css(_templateObject7(), color("".concat(level, ".main")));
};

export var MessageIconStyle = styled(MessageIconWrapper).withConfig(getPropsBlocker(propertyList, false))(_templateObject8(), pixelToRem(24), spacing(2), spacing(4), spacing(4), getIconDynamicStyle);
export var MessageCloseButton = styled.a.withConfig(getPropsBlocker(propertyList))(_templateObject9(), noTextInteraction, color('neutral.05'), pixelToRem(fontSize03), spacing(5), spacing(2), spacing(4));